export default __webpack_public_path__ + "images/cfa7a4239234c4780a15ddaf31a98445.png";